<template>
  <div id="footerSection">
    <h1>Bangkok Lotteries</h1>

    <hr class="coloredLine" />

    <div class="desktopFooterContainer">
      <div class="flexView">
        <div class="flexSectionLeft">
          <div class="footerMenu">
            <router-link to="/responsible-gambling">
              <img src="../assets/arrow-small.png" alt />
              <span v-if="this.langChosen === 'gr'">การพนันอย่างมีความรับผิดชอบ</span>
              <span v-else>Responsible Gambling</span>
            </router-link>
          </div>

          <div class="footerMenu">
            <router-link to="/contact-us">
              <img src="../assets/phone-circle-small.png" alt />
              <span v-if="this.langChosen === 'gr'">ติดต่อเรา</span>
              <span v-else>Contact Us</span>
            </router-link>
          </div>

          <div class="footerMenu">
            <router-link to="/about-us">
              <img src="../assets/question-mark-icon.png" alt />
              <span v-if="this.langChosen === 'gr'">เกี่ยวกับเรา</span>
              <span v-else>About Us</span>
            </router-link>
          </div>

          <div class="footerMenu">
            <router-link to="/privacy-policy">
              <img src="../assets/lock-icon.png" alt />
              <span v-if="this.langChosen === 'gr'">นโยบายความเป็นส่วนตัว</span>
              <span v-else>Privacy Policy</span>
            </router-link>
          </div>
        </div>

        <div class="flexSection rightFlex">
          <div class="footerMenu" @click="chooseLang('gr')">
            <img src="../assets/language.png" alt />
            กรีก
          </div>

          <div class="footerMenu" @click="chooseLang('en')">
            <img src="../assets/language.png" alt />
            English
          </div>

          <img src="../assets/wla-logo.jpg" alt="WLA Logo" class="logoWla" />
        </div>
      </div>

      <div class="rightFooterDesktop">
        <div class="subscribeNow">
          <span v-if="this.langChosen === 'gr'">
            <input type="text" placeholder="ที่อยู่อีเมลของคุณ" />
          </span>
          <span v-else>
            <input type="text" placeholder="Your email" />
          </span>

          <div>
            <span v-if="this.langChosen === 'gr'">ติดตาม</span>
            <span v-else>Subscribe</span>
          </div>
        </div>

        <div class="elseElse">
          <div class="elseLeft">
            <div class="elseRow">
              <b>
                <span v-if="this.langChosen === 'gr'">สายการดูแล</span>
                <span v-else>Care Line</span>
              </b>

              <div class="elseRowFlex">
                <div class="image">
                  <img src="../assets/phone-icon.png" alt="Phone Icon" />
                </div>
                <div class="tulisan">+66-4-4655464</div>
              </div>

              <div class="elseRowFlex">
                <div class="image">
                  <img src="../assets/mail-icon.png" alt="Mail Icon" />
                </div>
                <div class="tulisan">admin@bangkoklotteries.com</div>
              </div>
            </div>
          </div>

          <div class="elseRight">
            <b>
              <span v-if="this.langChosen === 'gr'">ดาวน์โหลดแอพของเรา</span>
              <span v-else>Download Our App</span>
            </b>
            <div class="elseRightRow">
              <img src="../assets/android-icon.png" alt="Android Icon" />
              <img src="../assets/apple-icon.png" alt="Apple Icon" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { EventBus } from '../main';

export default {
  methods: {
    chooseLang(lang) {
      localStorage.setItem('langChosen', lang);
      EventBus.$emit('setLang');
    },
  },
};
</script>

<style>
#footerSection {
  background-color: var(--darkColor);
  color: var(--yellowPrim);
  padding: 5vw;
}

.footerMenu {
  margin-bottom: 3.5vw;
  padding-left: 3.5vw;
  cursor: pointer;
}

.footerMenu a,
.rightFlex .footerMenu {
  color: var(--lightColor);
  text-decoration: none;
  display: flex;
  align-items: center;
}

.footerMenu a img,
.rightFlex .footerMenu img {
  width: 3vw;
  margin-right: 2vw;
}

h1 {
  margin: 0;
  margin-bottom: 4vw;
}

.coloredLine {
  display: block;
  height: 1px;
  border: 0;
  border-top: 1px solid var(--yellowPrim);
  margin: 1em 0;
  padding: 0;
}

.subscribeNow {
  display: flex;
  margin-top: 5vw;
}

.subscribeNow input {
  flex-grow: 1;
  border: none;
  border-radius: 1vw;
  padding: 0 3vw;
  outline: none;
}

.subscribeNow div {
  background-color: var(--yellowPrim);
  color: var(--darkColor);
  font-weight: bold;
  padding: 2vw 3vw;
  border-radius: 1vw;
  margin-left: 2vw;
}

.elseElse {
  display: flex;
  justify-content: space-between;
  margin-top: 5vw;
}

.elseRowFlex {
  font-size: 90%;
  margin-top: 2vw;
  align-items: center;
}

.elseRowFlex:first-of-type {
  margin-top: 3vw;
}

.elseLeft {
  width: 60%;
}

.elseRight {
  width: 40%;
}

.elseRowFlex {
  display: flex;
}

.image {
  display: flex;
  align-items: center;
}

.image img {
  width: 5vw;
  margin-right: 2vw;
}

.elseRightRow {
  padding: 2vw;
}

.elseRightRow img {
  width: 10vw;
  margin-right: 4vw;
}

.flexView {
  display: flex;
  justify-content: space-between;
}

.flexSection {
  width: 60%;
}

.flexSection {
  width: 40%;
}

.logoWla {
  width: 80%;
}

.rightFlex {
  text-align: center;
}

@media screen and (min-width: 768px) {
  #footerSection {
    padding: 50px;
  }

  #footerSection h1 {
    margin-bottom: 10px;
  }

  .flexView {
    width: 35%;
  }

  .footerMenu {
    margin-bottom: 25px;
    padding-left: 15px;
  }

  .footerMenu a img,
  .rightFlex .footerMenu img {
    width: 25px;
    cursor: pointer;
    margin-right: 18px;
  }

  .logoWla {
    height: 80px;
  }

  .desktopFooterContainer {
    display: flex;
  }

  .subscribeNow {
    width: 50%;
    height: 40px;
    margin-top: 0;
    margin-right: 30px;
  }

  .subscribeNow input {
    padding: 10px 15px;
    margin-right: 0;
    border-radius: 5px;
  }

  .subscribeNow div {
    padding: 12px;
    border-radius: 5px;
    margin-left: 10px;
    cursor: pointer;
  }

  .elseElse {
    margin-top: 0;
    width: 70%;
  }

  .rightFooterDesktop {
    display: flex;
    justify-content: space-evenly;
  }

  .elseRowFlex:first-of-type {
    margin-top: 15px;
  }

  .elseRowFlex {
    margin-top: 15px;
  }

  .image img {
    width: 25px;
    margin-right: 15px;
  }

  .elseRightRow img {
    width: 50px;
    margin-right: 20px;
  }

  .rightFooterDesktop {
    justify-content: space-between;
    flex-grow: 1;
  }

  .elseRightRow {
    display: flex;
    padding: 10px;
  }

  .elseRight {
    margin-left: 30px;
  }

  .elseLeft {
    margin-left: 15px;
  }

  .desktopFooterContainer {
    justify-content: space-between;
  }

  .subscribeNow span {
    height: 35px;
  }

  .subscribeNow input {
    height: 20px;
  }
}
</style>
